module.exports = __webpack_public_path__ + "static/media/yeartc.c2b41e5d.png";